import ChatRoom from "@/components/ChatRoom";

/**
 * Standalone fullscreen chat page — designed to be embedded inside the
 * official Digital Revolution Radio iOS / Android apps via a webview
 * (or accessed directly at /chat from any mobile browser).
 *
 * Locked to exactly viewport height so the message list scrolls INSIDE
 * the box on phones — no extra page-level scrolling, no double header.
 * ChatRoom's own "THE PIT // live_chat // 001 online" bar is the only header.
 */
export default function ChatPage() {
  return (
    <main
      // h-[100dvh] uses the *dynamic* viewport (accounts for browser bars on mobile)
      className="bg-zinc-950 text-zinc-100 h-[100dvh] w-full flex flex-col overflow-hidden"
      data-testid="standalone-chat-page"
      // Override ChatRoom's default 640px min-height inside this layout
      style={{ "--chat-min-height": "0px" }}
    >
      <div className="flex-1 min-h-0 flex flex-col [&_#chat]:!min-h-0">
        <ChatRoom />
      </div>
    </main>
  );
}
